module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-7.610a73d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-7.jpg
// module id = TEOL
// module chunks = 0